import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import Logo from '../../assets/logos/AL.png';
import Tik from '../../assets/images/titok.png';

const HeaderAds = () => {
  const location = useLocation();

  const headerStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100%',
    zIndex: 999,
    backgroundImage: 'url(images/assets/Menu.jpg)',
    boxShadow: '0 4px 2px -2px #bda265',
  };

  return (
    <header
      id="header"
      className="header-one"
      style={{
        backgroundImage: 'url(images/assets/ban3.jpg)',
        backgroundSize: 'cover',
      }}
    >
      

      <div className="site-navigation" style={headerStyle}>
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <nav className="navbar navbar-expand-lg navbar-dark p-0 text-center">
                <button
                  className="navbar-toggler"
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target="#navbar-collapse"
                  aria-controls="navbar-collapse"
                  aria-expanded="false"
                  aria-label="Toggle navigation"
                >
                  <span className="navbar-toggler-icon"></span>
                </button>

                <div id="navbar-collapse" className="collapse navbar-collapse justify-content-center">
                  <ul className="nav navbar-nav mx-auto">
                    <li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                      <Link to="/" className="nav-link">
                        <img src={Logo} alt="Logo" style={{ width: '60px' }} />
                      </Link>
                    </li>

                    <li className={`nav-item ${location.pathname === '/' ? 'active' : ''}`}>
                      <Link to="/" className="nav-link" style={{ color: '#000' }}>
                        Accueil
                      </Link>
                    </li>

                    <li className={`nav-item dropdown ${location.pathname === '/about' ? 'active' : ''}`}>
                      <Link to="/about" className="nav-link dropdown-toggle">
                        Qui sommes-nous
                      </Link>
                    </li>

                    <li className={`nav-item dropdown ${location.pathname === '/Services' ? 'active' : ''}`}>
                      <Link to="/Services" className="nav-link dropdown-toggle">
                        Nos Services
                      </Link>
                    </li>

                    <li className={`nav-item dropdown ${location.pathname === '/Galerie' ? 'active' : ''}`}>
                      <Link to="/Galerie" className="nav-link dropdown-toggle">
                        Galerie
                      </Link>
                    </li>

                    <li className={`nav-item dropdown ${location.pathname === '/Azyekos-Lounges' ? 'active' : ''}`}>
                      <Link to="/Azyekos-Lounges" className="nav-link dropdown-toggle">
                        Azyekos Lounges
                      </Link>
                    </li>

                    <li className={`nav-item ${location.pathname === '/contact' ? 'active' : ''}`}>
                      <Link to="/contact" className="nav-link">
                        Contact
                      </Link>
                    </li>
                  </ul>
                </div>
              </nav>

              <div className="nav-search">
                <div className="col-lg-12 col-md-12 top-social text-center text-md-right">
                  <ul className="list-unstyled">
                  <ul className="list-unstyled">
                    <li>
                      <a title="Facebook" href="https://web.facebook.com/azyekos">
                        <span className="social-icon text-warning"><i className="fab fa-facebook-f"></i></span>
                      </a>
                      <a title="Twitter" href="https://www.youtube.com/@azyekos-Services">
                        <span className="social-icon text-warning"><i className="fab fa-youtube"></i></span>
                      </a>
                      <a title="Instagram" href="https://www.instagram.com/azyekos_services_/">
                        <span className="social-icon text-warning"><i className="fab fa-instagram"></i></span>
                      </a>

                      <a title="Instagram" href="https://www.tiktok.com/@azyekos.lounges?is_from_webapp=1&sender_device=pc">
                        <span className="social-icon text-warning"><img src={Tik} alt="TikTok" style={{ width: '17px', height: '17px' }} />
                        </span>
                      </a>
                     
                    </li>
                  </ul>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          <div className="search-block" style={{ display: 'none' }}>
            <label htmlFor="search-field" className="w-100 mb-0">
              <input
                type="text"
                className="form-control"
                id="search-field"
                placeholder="Type what you want and enter"
              />
            </label>
            <span className="search-close">&times;</span>
          </div>
        </div>
      </div>
    </header>
  );
};

export default HeaderAds;
